<template>
    <div>
        <div class="dialog-con">
            <my-form 
                v-model="form" 
                @submit="submit()" 
                label-width="100px" 
                v-show="show==false">

                <el-form-item 
                    class="yzmInput"
                    label="验证码" 
                    :rules="newRule('验证码', 'required')" 
                    prop="captcha">

                    <el-input 
                        v-model="form.captcha" 
                        clearable autocomplete="off">
                    </el-input>

                    <img 
                        class="position" 
                        id="captcha" 
                        style="cursor: pointer; cursor: hand; float:right; width: 120px; height:35px;"
                        onclick="this.src='/hzbtenderagentzero/admin/captcha.html?'+Math.random();" 
                        src="/hzbtenderagentzero/admin/captcha.html">
                </el-form-item>

                <el-form-item
                    label="注册手机号" 
                    :rules="newRule('注册手机号','mobile', 'required')" 
                    prop="phone">

                    <el-input 
                        v-model="form.phone" 
                        clearable 
                        autocomplete="off">
                    </el-input>
                    
                </el-form-item>
                <el-form-item 
                    label="手机验证码" 
                    :rules="newRule('手机验证码', 'required')" 
                    prop="sjyzm" 
                    class="yzmInput">
                        <el-input 
                            v-model="form.sjyzm" 
                            clearable 
                            autocomplete="off">
                        </el-input>
                        <el-button 
                            class="position" 
                            type="primary" 
                            :disabled="isDisable" 
                            @click="getYzm(1)" 
                            :loading="yzm_loading_controller">
                                {{yzmText}}
                        </el-button>
                </el-form-item>

                <template slot="btn" slot-scope="scope">
                    <el-button @click="scope.submitHandler" type="primary">
                        下一步
                    </el-button>
                </template>
            </my-form>
            <!-- 修改密码 -->
            <my-form 
                v-model="pwdform" 
                @submit="submitPwd()" 
                label-width="100px" 
                v-show="show">
        
                <el-form-item 
                    label="输入新密码" 
                    :rules="newRule('新密码', 'required')" 
                    prop="newpwd">

                    <el-input 
                        v-model="pwdform.newpwd" 
                        type="password" 
                        clearable autocomplete="off">
                    </el-input>
                    
                </el-form-item>
                <el-form-item 
                    label="确认新密码" 
                    :rules="newRule('新密码', 'required')" 
                    prop="qrpwd">
                    <el-input 
                        v-model="pwdform.qrpwd" 
                        clearable 
                        type="password" 
                        autocomplete="off">
                    </el-input>
                </el-form-item>

                <template slot="btn" slot-scope="scope">
                    <el-button @click="scope.submitHandler" type="primary">
                        确&nbsp;&nbsp;定
                    </el-button>
                </template>
            </my-form>
        </div>
    </div>
</template>

<script>

    export default {
       
        data: () => ({
            form: {
                captcha:'',
                phone:'',
                sjyzm:'',
                userid:''
            },
            pwdform:{
                newpwd:'',
                qrpwd:''
            },
            //控制验证码的字段
            yzm_loading_controller: false,
            isDisable: false,
            yzmText:'获取手机验证码',

            show:false


        }),
        methods: {

            submit() {
                var that = this
                that.$post(that.getGetters('bidUrl') + '/admin/backuserid.json', {
                    phone: that.form.phone,
                    sjyzm: that.form.sjyzm,
                }, function (data,res) {
                    that.form.userid = res.msg
                    that.show = true
                })
            },
            submitPwd() {
                var that = this
                if(that.pwdform.newpwd!= that.pwdform.qrpwd){
                    ShowMsg('两次输入的密码不相同！', 'error');
                }else{
                    that.$post(that.getGetters('bidUrl') + '/admin/modifypwd.json', {
                        phone: that.form.phone,
                        sjyzm: that.form.sjyzm,
                        captcha: that.form.captcha,
                        id: that.form.userid,
                        pwd: that.pwdform.newpwd
                    }, function (data, res) {
                        ShowMsgBox(res.msg, 'success', () => {
                            that.$emit('cancle');
                        });
                    })
                }
                
            },
            //获取验证码
            getYzm: function (i) {
                var that = this
                if(that.form.captcha==''){
                    ShowMsg('验证码不能为空', 'error');
                }else if(that.form.phone == ''){
                    ShowMsg('手机号不能为空', 'error');
                }else{
                    $.post(that.getGetters('bidUrl') + '/admin/VerificationTel.json', {
                        phone: that.form.phone,
                        captcha: that.form.captcha,
                    }, function (data) {
                        if (data.result){
                            that.$post(that.getGetters('bidUrl') + '/msg/sendyzmpwd.json', {
                                phone: that.form.phone,
                                captcha: that.form.captcha,
                            },function(data){
                                //倒计时
                                that.yzm_loading_controller = true;
                                that.isDisable = true
                                that.yzmText = '手机验证码已发送'
                                //倒计时
                                var remain = 60;
                                var int = setInterval(function () {
                                    if (remain != 0) {
                                        remain--
                                    } else {
                                        clearInterval(int);
                                    
                                        that.isDisable = false;
                                        that.yzm_loading_controller = false;
                                        that.yzmText = '获取手机验证码'
                                    }
                                }, 1000)
                            })
                        }else{
                            ShowMsg(data.msg,'error')
                        }
                        
                    })
                   
                }
                
            },
        },
        mounted() {
            var that = this
        }
    }
</script>

<style scoped lang="scss">
    .yzmInput{ position: relative; }
    .yzmInput .position{ position: absolute; z-index: 100; top: 4px; right:5px }
</style>

